import { forwardRef, useState } from 'react'
import { IconButton, InputAdornment, TextField, type TextFieldProps } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

type PasswordFieldProps = Omit<TextFieldProps, 'type'>

/**
 * Поле пароля с кнопкой «показать / скрыть» — для форм регистрации и
 * активации кабинета.
 */
export const PasswordField = forwardRef<HTMLDivElement, PasswordFieldProps>(function PasswordField(
  { InputProps, ...props },
  ref,
) {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  return (
    <TextField
      {...props}
      ref={ref}
      type={visible ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setVisible((current) => !current)}
              edge="end"
              aria-label={visible ? t('auth.hidePassword') : t('auth.showPassword')}
            >
              {visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
})
